
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useFormContext } from '../context/FormContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SecurityBadges from '../components/SecurityBadges';

const Processing: React.FC = () => {
  const { formData, resetForm } = useFormContext();
  const [processing, setProcessing] = React.useState(true);
  const [completed, setCompleted] = React.useState(false);

  useEffect(() => {
    // Simulate processing
    const timer = setTimeout(() => {
      setProcessing(false);
      // Simulate completion after processing
      setTimeout(() => {
        setCompleted(true);
      }, 1000);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
        <div className="form-container fade-in">
          {processing ? (
            <div className="text-center py-8">
              <div className="inline-block w-16 h-16 mb-4">
                <svg className="animate-spin h-16 w-16 text-deep-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-deep-blue mb-2">Ihre Anfrage wird bearbeitet</h2>
              <p className="text-gray-600">Bitte haben Sie einen Moment Geduld...</p>
            </div>
          ) : (
            <div className="text-center py-8 fade-in">
              {completed ? (
                <>
                  <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-green-100">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h2 className="text-xl font-semibold text-deep-blue mb-4">Anfrage erfolgreich übermittelt</h2>
                  <div className="mb-6 p-4 bg-gray-50 rounded-lg max-w-md mx-auto">
                    <h3 className="font-medium text-lg mb-2">Angefragte Person:</h3>
                    <p><span className="font-medium">Name:</span> {formData.firstName} {formData.lastName}</p>
                    <p><span className="font-medium">Letzter bekannter Wohnort:</span> {formData.city}, {formData.country}</p>
                    {formData.postalCode && (
                      <p><span className="font-medium">PLZ:</span> {formData.postalCode}</p>
                    )}
                  </div>
                  <p className="text-gray-600 mb-6">
                    Vielen Dank für Ihre Anfrage. Die Suche wurde gestartet und Sie werden in Kürze über das Ergebnis informiert.
                  </p>
                  <Link 
                    to="/" 
                    onClick={resetForm}
                    className="inline-block bg-deep-blue text-white px-6 py-3 rounded font-medium hover:bg-deep-blue/90 transition-colors"
                  >
                    Zurück zur Startseite
                  </Link>
                </>
              ) : (
                <>
                  <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-blue-100">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-deep-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </div>
                  <h2 className="text-xl font-semibold text-deep-blue mb-2">Adresssuche wird initialisiert</h2>
                  <p className="text-gray-600 mb-6">
                    Wir bereiten Ihre Anfrage vor. Dies dauert nur einen Moment...
                  </p>
                </>
              )}
            </div>
          )}
        </div>
        
        <SecurityBadges />
      </main>
      
      <Footer />
    </div>
  );
};

export default Processing;
